import React, { FC, Ref, ReactElement } from 'react';
import { Carousel } from 'antd';
import { CarouselRef } from 'antd/lib/carousel';
import { LeftArrowBtn, RightArrowBtn, SliderCont } from './Slider.styles';
import ArrowButton from '../ArrowButton/ArrowButton';

interface ISlider {
  activeSlide: number;
  goToSlide: (newActiveSlide: number) => void;
  carouselRef: Ref<CarouselRef>;
  children?: ReactElement | any;
  slidesLength: number;
  height?: string;
}

const Slider: FC<ISlider> = ({
  activeSlide,
  goToSlide,
  carouselRef,
  children,
  slidesLength,
  height,
}) => {
  return (
    <SliderCont height={height} id="SliderCont">
      <Carousel ref={carouselRef}>{children}</Carousel>
      <LeftArrowBtn id="LeftArrowBtn">
        <ArrowButton
          onClick={() => {
            if (activeSlide !== 0) {
              goToSlide(activeSlide - 1);
            } else {
              goToSlide(slidesLength - 1);
            }
          }}
          left
        />
      </LeftArrowBtn>
      <RightArrowBtn id="RightArrowBtn">
        <ArrowButton
          onClick={() => {
            if (activeSlide !== slidesLength - 1) {
              goToSlide(activeSlide + 1);
            } else {
              goToSlide(0);
            }
          }}
        />
      </RightArrowBtn>
    </SliderCont>
  );
};

export default Slider;
